<template>
  <div class="order-detail-tab order-detail-tab--aftersales">
    <template v-if="!orderId">
      <a-empty description="暂无订单数据" />
    </template>
    <template v-else-if="loading">
      <a-spin tip="加载中..." />
    </template>
    <template v-else-if="!hasData">
      <a-empty description="暂无售后记录" />
    </template>
    <div v-else class="tab-content">
      <a-table
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :scroll="{ y: 360 }"
        row-key="id"
      >
        <template slot="orderName" slot-scope="val">
          <span :title="val">{{ val || '-' }}</span>
        </template>
        <template slot="userName" slot-scope="val">
          {{ val || '-' }}
        </template>
        <template slot="read" slot-scope="val">
          <a-tag v-if="readTypeText(val) !== '-'" :color="readTypeColor(val)">{{ readTypeText(val) }}</a-tag>
          <span v-else>-</span>
        </template>
        <template slot="reason" slot-scope="val">
          <span :title="val">{{ val || '-' }}</span>
        </template>
        <template slot="proof" slot-scope="val">
          <span :title="val">{{ val || '-' }}</span>
        </template>
        <template slot="picture" slot-scope="val">
          <template v-if="pictureList(val).length">
            <a-popover trigger="click" placement="left">
              <template slot="content">
                <div class="after-pictures">
                  <img
                    v-for="(url, idx) in pictureList(val)"
                    :key="idx"
                    v-viewer
                    :src="url"
                    class="after-picture-thumb after-picture-thumb--clickable"
                    alt="凭证图"
                  />
                </div>
              </template>
              <a>{{ pictureList(val).length }} 张图</a>
            </a-popover>
          </template>
          <span v-else>-</span>
        </template>
        <template slot="createTime" slot-scope="val">
          {{ formatDateTime(val) }}
        </template>
      </a-table>
    </div>
  </div>
</template>

<script>
import { getOrderAfterSales } from '@/api/order/order'

const READ_TYPE_MAP = {
  0: '发起售后',
  1: '联系客户',
  2: '售后完成'
}
const READ_TYPE_COLOR = {
  0: 'orange',
  1: 'blue',
  2: 'green'
}

export default {
  name: 'AfterSalesInfo',
  props: {
    orderId: { type: [Number, String], default: null }
  },
  data () {
    return {
      hasData: false,
      loading: false,
      list: [],
      columns: [
        { title: '用户', dataIndex: 'userName', key: 'userName', width: 130, scopedSlots: { customRender: 'userName' } },
        { title: '处理类型', dataIndex: 'read', key: 'read', width: 100, scopedSlots: { customRender: 'read' } },
        { title: '轮次', dataIndex: 'alternately', key: 'alternately', width: 70 },
        { title: '售后原因', dataIndex: 'reason', key: 'reason', ellipsis: true, scopedSlots: { customRender: 'reason' } },
        { title: '凭证/说明', dataIndex: 'proof', key: 'proof', width: 120, ellipsis: true, scopedSlots: { customRender: 'proof' } },
        { title: '图片', dataIndex: 'picture', key: 'picture', width: 80, scopedSlots: { customRender: 'picture' } },
        { title: '创建时间', dataIndex: 'createTime', key: 'createTime', width: 170, scopedSlots: { customRender: 'createTime' } }
      ]
    }
  },
  watch: {
    orderId: {
      immediate: true,
      handler (id) {
        if (id) this.fetchList()
        else {
          this.list = []
          this.hasData = false
        }
      }
    }
  },
  methods: {
    async fetchList () {
      if (!this.orderId) return
      this.loading = true
      this.hasData = false
      try {
        const res = await getOrderAfterSales(this.orderId)
        const data = (res && res.data) ? res.data : []
        this.list = Array.isArray(data) ? data : []
        this.hasData = this.list.length > 0
      } catch (e) {
        this.list = []
        this.hasData = false
      } finally {
        this.loading = false
      }
    },
    readTypeText (val) {
      return READ_TYPE_MAP[val] != null ? READ_TYPE_MAP[val] : (val != null ? String(val) : '-')
    },
    readTypeColor (val) {
      return READ_TYPE_COLOR[val] != null ? READ_TYPE_COLOR[val] : 'default'
    },
    pictureList (str) {
      if (!str || typeof str !== 'string') return []
      return str.split(',').map(s => s.trim()).filter(Boolean)
    },
    formatDateTime (val) {
      if (!val) return '-'
      const d = new Date(val)
      if (isNaN(d.getTime())) return val
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      const h = String(d.getHours()).padStart(2, '0')
      const min = String(d.getMinutes()).padStart(2, '0')
      const s = String(d.getSeconds()).padStart(2, '0')
      return `${y}-${m}-${day} ${h}:${min}:${s}`
    }
  }
}
</script>

<style lang="less" scoped>
.order-detail-tab {
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}
.order-detail-tab .tab-content {
  width: 100%;
  padding: 16px;
  align-self: flex-start;
}
.after-pictures {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  max-width: 320px;
}
.after-picture-thumb {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 4px;
}
.after-picture-thumb--clickable {
  cursor: pointer;
}
</style>
